var UrlFilter = (function ($) {
    'use strict';

    var sortMap = {
        scope: 0,
        price: 1,
        sort: 2,
        search: 3
    };

    var sortFunction = function(a, b) {
        return (sortMap[a] || 0) - (sortMap[b] || 0);
    };

    function UrlFilter(url, filters) {
        this.url = undefined;
        this.filterQuery = filters;
        this.params = {};

        this.setUrl(url);
    }

    UrlFilter.prototype = {
        setUrl: function (url) {
            this.url = url;

            if(this.hasFilter()) {
                var self = this;

                $.each(this.filterQuery.split('/'), function () {
                    var group = this.split(':');
                    self.params[group[0]] = group[1];
                });
            }

            this.url = this.getUrlWithoutFilters().replace(/\/?(\?|#|$)/, '/$1');

            return this;
        },

        setRawUrl: function(url) {
            this.url = url.replace(/\/?(\?|#|$)/, '/$1');

            return this;
        },

        sort: function() {
            var
                self = this,
                sorted = {};

            Object.keys(this.params).sort(sortFunction).forEach(function(key) {
                sorted[key] = self.params[key];
            });

            this.params = sorted;

            return this;
        },

        getParams: function() {
            return this.sort().params;
        },

        getParamsExcept: function(param) {
            var tempParams = {};

            $.each(this.getParams(), function (key, value) {
                if(key !== param) {
                    tempParams[key] = value;
                }
            });

            return tempParams;
        },

        getUrlWithoutFilters: function () {
            return this.url.replace(this.filterQuery, '').replace(/\/$/, "");
        },

        hasFilter: function () {
            return this.filterQuery !== '';
        },

        setParam: function (name, value, addEmpty) {
            if (value || addEmpty) {
                this.params[name] = encodeURIComponent(value);
            } else {
                this.removeParam(name);
            }

            return this;
        },

        removeParam: function (name) {
            if (this.params[name] !== undefined) {
                delete this.params[name];
            }

            return this;
        },

        removeExcept: function(name) {
            var exceptValue = this.getParam(name);

            this.params = {};
            this.setParam(name, exceptValue, true);

            return this;
        },

        getParam: function (name, defaultValue) {
            return this.params[name] || defaultValue;
        },

        getFiltersAsString: function () {
            var params = [];

            $.each(this.getParams(), function (key, value) {
                params.push(key + ':' + value);
            });

            if (params.length === 0) {
                return '';
            }

            return params.join('/').replace(/\/$/, "");
        },

        getUrl: function () {
            var url = this.getUrlWithoutFilters() + '/' + this.getFiltersAsString();

            return url.replace(/\/$/, "");
        }
    };

    return UrlFilter;
})(jQuery);
